import React, { Component } from "react";
import { observer } from "mobx-react";
import ToolkitProvider from "react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";
import InfiniteScroll from "react-infinite-scroll-component";
import { Col, Row } from "reactstrap";
import { buscaFiltrarVazio } from '../../../../utils/mensagens';
import { HeaderTableFixed } from "../../../../utils/headerTableFixed";
import LoadingImage from "../../../comum/components/LoadingImage";

@observer
export class TabelaTriagemDepot extends Component {
    constructor(props) {
        super(props);
        this.controller = this.props.controller;
        window.addEventListener('scroll', HeaderTableFixed)
    }

    componentDidMount() {
        console.log('montou');
        // this.controller.listarVeiculos();
    }



    render() {
            return (
                // <InfiniteScroll
                //     dataLength={this.controller.itens.length}
                //     next={this.controller.loadNextTurn}
                //     hasMore={this.controller.hasMore}
                //     loader={<LoadingImage />}
                // >
                this.controller.loadingVeiculos ? <ToolkitProvider
                        keyField="ProcVeicId"
                        data={[...this.controller.veiculos]}
                        columns={[...this.controller.colunas]}>
                        {props => (
                            <div id="tableHeaderFixed">
                                <BootstrapTable bootstrap4
                                    striped
                                    bordered={false}
                                    noDataIndication={ this.controller.loadingVeiculos ?
                                        <LoadingImage /> : 'Não há dados'}
                                    classes="tabela"
                                    //pagination={paginationFactory()}
                                    {...props.baseProps} />
                            </div>)}
                    </ToolkitProvider> : <ToolkitProvider
                        keyField="ProcVeicId"
                        data={[...this.controller.veiculos]}
                        columns={[...this.controller.colunas]}>
                        {props => (
                            <div id="tableHeaderFixed">
                                <BootstrapTable bootstrap4
                                    striped
                                    bordered={false}
                                    noDataIndication={ this.controller.loadingVeiculos ?
                                        <LoadingImage /> : 'Não há dados'}
                                    classes="tabela"
                                    //pagination={paginationFactory()}
                                    {...props.baseProps} />
                            </div>)}
                    </ToolkitProvider>
                // </InfiniteScroll>
            )
        }
    // }
}



// WEBPACK FOOTER //
// ./src/modules/consultas/triagem-depot/components/TabelaTriagemDepot.js